<script setup lang="ts">
import { DropdownMenuRoot } from "reka-ui"

defineOptions({
  inheritAttrs: false,
})

const emit = defineEmits(["open", "close"])

function handleUpdateOpen(isOpen: boolean) {
  if (isOpen) {
    emit("open")
  } else {
    emit("close")
  }
}

const open = ref(false)
</script>

<template>
  <div :class="$attrs.class" class="relative flex items-center" v-bind="$attrs">
    <DropdownMenuRoot v-model:open="open" @update:open="handleUpdateOpen">
      <slot />
    </DropdownMenuRoot>
  </div>
</template>
